import BetModel from "slotworks/model/bets/bet-model";
import GameState from "slotworks/model/game-state";
import { Services } from "slotworks/services/services";

export function ResetGameCommand() {
    GameState.newGame(BetModel.getTotalStake());

    Services.transaction.setWinnings(0, 0).execute();
}
